import React from 'react';
import MUIButton from '@mui/material/Button';
import { ButtonProps as MuiButtonProps } from '@mui/material/Button';

export type ButtonProps = {
    onClickHandler: () => void;
    id?: string;
    label: string;
    disabled?: boolean;
    variant?: MuiButtonProps['variant'];
    fullWidth?: boolean;
    style?: React.CSSProperties;
};

const Button = ({ onClickHandler, id, label, disabled, variant, fullWidth, style }: ButtonProps): JSX.Element => {
    const buttonVariant = variant ? variant : 'contained';
    return (
        <MUIButton
            onClick={() => onClickHandler()}
            disabled={disabled}
            variant={buttonVariant}
            fullWidth={fullWidth}
            id={id}
            style={style}
        >
            {label}
        </MUIButton>
    );
};

export default Button;
